import Header from "@/components/main/Header";
import ContactUsComp from "@/components/contact-us";
import Footer from "@/components/main/Footer";

export default function Page() {
  return (
    <>
      <Header />
      <ContactUsComp />
      <Footer />
    </>
  );
}
